import { render, staticRenderFns } from "./CreateProductFeaturesModal.vue?vue&type=template&id=90861dfc&scoped=true"
import script from "./CreateProductFeaturesModal.vue?vue&type=script&lang=js"
export * from "./CreateProductFeaturesModal.vue?vue&type=script&lang=js"
import style0 from "./CreateProductFeaturesModal.vue?vue&type=style&index=0&id=90861dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90861dfc",
  null
  
)

export default component.exports